import { Stack, Text, useMantineTheme } from '@mantine/core'
import { useMediaQuery } from '@mantine/hooks'
import React from 'react'

import { ResultsActionProps } from '../NomineesList'

const ResultsAction: React.FC<ResultsActionProps> = ({ status }) => {
  const theme = useMantineTheme()
  const isBreakpoint = useMediaQuery(`(max-width: ${theme.breakpoints.md})`)
  return (
    status === 'REMOVED' && (
      <Stack style={{ flexDirection: 'row', justifyContent: isBreakpoint ? 'center' : 'flex-end' }}>
        <Text>Candidate Removed by Foundation</Text>
      </Stack>
    )
  )
}

export default ResultsAction
